import { makeStyles } from '@material-ui/core/styles'
import { color, focusRing, fontFamily, mdUp } from './tokens'

// Mirrors the mock's RadioGroup cards, Label and Input.
export const useFormStyles = makeStyles({
  options: { display: 'grid', gap: 12 },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    border: `1px solid ${color.border}`,
    borderRadius: 8,
    cursor: 'pointer'
  },
  optionSelected: {
    borderColor: color.primary,
    backgroundColor: color.primary5
  },
  radio: {
    // Radix RadioGroupItem: 16px circle, primary border, 10px primary dot when checked.
    appearance: 'none',
    WebkitAppearance: 'none',
    width: 16,
    height: 16,
    margin: 0,
    flexShrink: 0,
    border: `1px solid ${color.primary}`,
    borderRadius: '50%',
    cursor: 'pointer',
    outline: 'none',
    '&:checked': {
      background: `radial-gradient(circle, ${color.primary} 0 5px, transparent 5.5px)`
    },
    '&:focus-visible': { boxShadow: focusRing },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.5 }
  },
  optionText: { flex: 1, fontSize: 14, lineHeight: '20px' },
  optionTitle: { margin: 0, fontSize: 14, lineHeight: '20px', fontWeight: 500, color: color.foreground },
  optionSub: { margin: 0, fontSize: 12, lineHeight: '16px', color: color.mutedForeground },
  heading: { margin: 0, fontSize: 14, lineHeight: '20px', fontWeight: 500, color: color.foreground },
  fields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 12
  },
  wide: { gridColumn: 'span 2 / span 2' },
  field: { '& > * + *': { marginTop: 6 } },
  label: {
    display: 'block',
    fontSize: 14,
    lineHeight: 1,
    fontWeight: 500,
    color: color.foreground
  },
  input: {
    display: 'flex',
    width: '100%',
    height: 40,
    boxSizing: 'border-box',
    padding: '8px 12px',
    backgroundColor: color.background,
    border: `1px solid ${color.border}`,
    borderRadius: 6,
    color: color.foreground,
    fontFamily,
    fontSize: 16,
    lineHeight: '24px',
    outline: 'none',
    '&::placeholder': { color: color.mutedForeground, opacity: 1 },
    '&:focus-visible, &.StripeElement--focus': { boxShadow: focusRing },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.5 },
    [mdUp]: { fontSize: 14, lineHeight: '20px' }
  },
  stripeInput: {
    // Stripe renders an iframe inside; 9 + 20 (iframe line height) + 9 + 2 (border) = 40px, like the mock.
    display: 'block',
    padding: '9px 12px',
    '& > *': { width: '100%' }
  },
  fieldError: { margin: 0, fontSize: 12, lineHeight: '16px', color: color.destructive }
})
